var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M20.619 14.945a.52.52 0 0 1-.501.151 3.1 3.1 0 0 1-1.63-.932l-4.485.525a5.9 5.9 0 0 1-1.094 1.514q-1.491 1.49-3.564 1.7a.57.57 0 0 1-.443-.14.53.53 0 0 1-.186-.419l-.02-4.467H3.5c-.155 0-.985-.73-.985-.877s.838-.88.994-.88h5.194l-.011-4.468a.54.54 0 0 1 .163-.396.56.56 0 0 1 .465-.163 5.9 5.9 0 0 1 2.772 1.037 5.77 5.77 0 0 1 1.91 2.178l4.484.524.07-.07a3.1 3.1 0 0 1 1.573-.85.49.49 0 0 1 .448.11.53.53 0 0 1 .204.426v5.1a.54.54 0 0 1-.163.397z"
})));
export default SvgPin;